import { render } from "./privacy-policy.vue?vue&type=template&id=97040aa6&scoped=true"
import script from "./privacy-policy.vue?vue&type=script&lang=js"
export * from "./privacy-policy.vue?vue&type=script&lang=js"

import "./privacy-policy.vue?vue&type=style&index=0&id=97040aa6&lang=scss&scoped=true"

import exportComponent from "/var/www/html/neo-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97040aa6"]])

export default __exports__